import React from "react";
import { Col } from "react-bootstrap";
import MyBadge from "../MyBadge";
import HelpButton from "../../HelpContent/HelpButton";
import ContactsIcon from "../../../assets/icons/contacts_main.svg2";
import AssetIcon from "../../../assets/icons/asset-01.svg2";
import ApiIcon from "../../../assets/icons/api_type-01.svg2";
import LdapIcon from "../../../assets/icons/ldap-01.svg2";
import FileUploadIcon from "../../../assets/icons/upload_file-01.svg2";
import GroupIcon from "../../../assets/icons/groups.svg2";
import CalenderIcon from "../../../assets/icons/calendar.svg2";

const howToImportOptions = [
  {
    name: "ldap",
    heading: "LDAP(Lightweight Directory Access protocol)",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: LdapIcon,
  },
  {
    name: "file",
    heading: "File Upload(.ICS,.CSV)",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: FileUploadIcon,
  },
  {
    name: "api",
    heading: "Connect to new API",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: ApiIcon,
  },
];

const whatToImportOptions = [
  {
    name: "groups",
    heading: "Groups",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: GroupIcon,
  },
  {
    name: "calendar",
    heading: "Calendar",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: CalenderIcon,
  },
  {
    name: "asset",
    heading: "Asset",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: AssetIcon,
  },
  {
    name: "contacts",
    heading: "Contacts",
    subheading: "Lorem ipsum dolor sit amet consectetur adipisicing elit.",
    icon: ContactsIcon,
  },
];
export function DropdownButton({ option }) {
  return (
    <div className="">
      <div className="d-flex align-items-center">
        <div className="me-3">
          <option.icon width={50} />
        </div>
        <div className=" d-flex flex-column align-items-start ms-3">
            <h5 className="fw-bold">{option.heading}</h5>
            <h6 className="text-secondary">{option.subheading}</h6>
          
        </div>
      </div>
    </div>
  );
}

export default function ImportOptions({
  howtoImport,
  setHowtoImport,
  whattoImport,
  setWhattoImport,
}) {
  return (
    <div>
      <div className="mb-3">
        <span className="fw-bold">
          <MyBadge count={1} />
        </span>
        <span className="fs-4 fw-bold ms-2">
          What would you like to import?
        </span>
        <span className="text-secondary ms-2 p-2">
          <HelpButton />
        </span>
      </div>
      <div
        className="overflow-auto d-flex flex-column p-3 "
        style={{
          maxHeight: 300,
          scrollbarColor:
            "var(--color-dark-purple) rgba(var(--color-blue),0.1)",
        }}
      >
        {whatToImportOptions.map((o) => (
          <button
            type="button"
            className={`btn p-3 bg-white  mb-2 rounded-4 ${
              whattoImport === o ? "opacity-100 border" : "opacity-50"
            }`}
            onClick={(e) => {
              e.preventDefault();
              setWhattoImport(o);
            }}
          >
            <DropdownButton option={o} />
          </button>
        ))}
      </div>

      <hr className="text-secondary" />
      <div className="mt-5 mb-3">
        <span className="fw-bold">
          <MyBadge count={2} />
        </span>
        <span className="fs-4 fw-bold ms-2">
          How would you like to import data?
        </span>
        <span className="text-secondary ms-2 p-2">
          <HelpButton />
        </span>
      </div>

      <div
        className="overflow-auto d-flex flex-column p-3"
        style={{ maxHeight: 300 }}
      >
        {howToImportOptions.map((o) => (
          <button
            type="button"
            className={`btn p-3 bg-white mb-2 rounded-4  align-items-start ${
              howtoImport === o ? "opacity-100 border" : "opacity-50"
            }`}
            onClick={(e) => {
              e.preventDefault();
              setHowtoImport(o);
            }}
          >
            <DropdownButton option={o} />
          </button>
        ))}
      </div>
    </div>
  );
}
